export const regionsBC = [
    {
        name: 'BC-CARIBOO',
        label: 'Prince George',
    },
    {
        name: 'BC-KOOTENAY',
        label: 'Nelson, Cranbrook',
    },
    {
        name: 'BC-NANAIMO',
        label: 'Nanaimo',
    },
    {
        name: 'BC-PRINCE-RUPERT',
        label: 'Prince Rupert, Terrace, Smithers',
    },
    {
        name: 'BC-VANCOUVER',
        label: 'Vancouver, New Westminster',
    },
    {
        name: 'BC-VICTORIA',
        label: 'Victoria',
    },
    {
        name: 'BC-YALE',
        label: 'Kamloops, Kelowna, Vernon',
    },
]

export const regionsAB = [
    {
        name: 'AB-SOUTH',
        label: 'Calgary & Southern AB (Airdrie, Strathmore, High River, Cochrane, Banff, etc.)',
    },
    {
        name: 'AB-CENTRAL',
        label: 'Edmonton & Northern AB (Lloydminster, Wetaskiwin, Whitecourt, Jasper, Lac La Biche, etc.)',
    },
    {
        name: 'AB-NORTH',
        label: 'North (Grande Prairie, Fort McMurray, Grande Cache, Peace River, High Level, etc.)',
    },
    {
        name: 'AB-MID-CENTRAL',
        label: 'Red Deer & Central AB (Lacombe, Olds, Provost, etc.)',
    },
    {
        name: 'AB-EAST',
        label: 'Lethbridge & Southeast AB (Drumheller, Hanna, Oyen, Medicine Hat, etc.)',
    },
]

export const regionsON = [
    {
        name: 'ON-GTA',
        label: 'Toronto and GTA',
    },
    {
        name: 'ON-OTTAWA',
        label: `Ottawa and surrounding (Cornwall, L'Orignal, etc.)`,
    },
    {
        name: 'ON-NORTH',
        label: 'North (Sudbury, Thunder Bay, North Bay, Sault Ste. Marie, etc.)',
    },
    {
        name: 'ON-EAST',
        label: 'East (Kingston, Frontenac, Peterborough, Belleville, etc.)',
    },
    {
        name: 'ON-SOUTH',
        label: 'Central (Simcoe county)',
    },
    {
        name: 'ON-WEST',
        label: 'West (Hamilton, Guelph, Kitchener, Cambridge, Brantford, Niagara, etc.)',
    },
    {
        name: 'ON-SOUTHWEST',
        label: 'Southwest (London, Woodstock, Stratford, Sarnia, Chatham, Windsor, etc.)',
    },
]
const regions = [
    {
        name: 'MTL',
        label: 'Montréal',
    },
    {
        name: 'LAV',
        label: 'Laval',
    },
    {
        name: 'CNA',
        label: 'Québec / Capitale-Nationale',
    },
    {
        name: 'AT',
        label: 'Abitibi-Témiscamingue',
    },
    {
        name: 'BSL',
        label: 'Bas-Saint-Laurent',
    },
    {
        name: 'CQ',
        label: 'Drummondville / Victoriaville / Centre du Québec ',
    },
    {
        name: 'CA',
        label: 'Chaudière-Appalaches',
    },
    {
        name: 'CN',
        label: 'Côte-Nord',
    },
    {
        name: 'ES',
        label: 'Estrie',
    },
    {
        name: 'GM',
        label: 'Gaspésie-îles-de-la-Madeleine',
    },
    {
        name: 'LAN',
        label: 'Lanaudière',
    },
    {
        name: 'LAU',
        label: 'Laurentides',
    },
    {
        name: 'MAU',
        label: 'Mauricie',
    },
    {
        name: 'MON',
        label: 'Montérégie',
    },
    {
        name: 'NOR',
        label: 'Nord du Québec',
    },
    {
        name: 'OUT',
        label: 'Outaouais',
    },
    {
        name: 'SAG',
        label: 'Saguenay-Lac-Saint-Jean',
    },
]

export default regions

export const regionsMappings = (function () {
    const mappings = {
        ON: 'Tout l’Ontario',
        QC: 'Tout le Québec',
        AB: 'Tout l’Alberta',
        BC: 'Toute la Colombie-Britannique',
        GTM: 'Grand Montréal',
    }
    regions.forEach((type) => (mappings[type.name] = type.label))
    regionsON.forEach((type) => (mappings[type.name] = type.label))
    regionsBC.forEach((type) => (mappings[type.name] = type.label))
    regionsAB.forEach((type) => (mappings[type.name] = type.label))

    return mappings
})()

export const invertedRegionsMappings = (function () {
    const mappings = {
        'Tout l’Ontario': 'ON',
        'Tout le Québec': 'QC',
        'Tout l’Alberta': 'AB',
        'Toute la Colombie-Britannique': 'BC',
        'Grand Montréal': 'GTM',
    }
    regions.forEach((type) => (mappings[type.label] = type.name))
    regionsON.forEach((type) => (mappings[type.label] = type.name))
    regionsBC.forEach((type) => (mappings[type.label] = type.name))
    regionsAB.forEach((type) => (mappings[type.label] = type.name))
    return mappings
})()
